import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Action } from "@ngrx/store";
import { ActionCreator, TypedAction } from "@ngrx/store/src/models";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ConfirmationAction } from "../../../project/store/actions/generic.action";
import { DeleteConfirmationComponent } from "./delete-confirmation.component";

@Injectable({
    providedIn: "root",
})
export class DeleteConfirmationService {
    constructor(private dialog: MatDialog) {}

    /**
     * @param payload
     * @param cancelAction
     * @param confirmAction
     * @param display
     * @param actionTitle
     * @param suffixText
     * @param confirmation
     * @deprecated
     */
    open<T>(
        payload: T,
        cancelAction: new (data?: T) => Action,
        confirmAction: new (data: T) => Action,
        display?: string,
        // really should be "Delete" | "Remove" | "Deactivate" | "Activate" | "Suspend" | "Reset", but localization complpicates this
        actionTitle = $localize`:@@SHARED.TEXT.DELETE:Delete`,
        suffixText = "",
        confirmation?: ConfirmationAction
    ): Observable<Action> {
        const dialogRef: MatDialogRef<DeleteConfirmationComponent> = this.dialog.open(DeleteConfirmationComponent);

        dialogRef.componentInstance.confirmationActionData = payload;
        dialogRef.componentInstance.actionTitle = actionTitle;
        dialogRef.componentInstance.suffix = suffixText;
        dialogRef.componentInstance.confirmationData = confirmation;

        if (display) {
            dialogRef.componentInstance.display = display;
        }

        return dialogRef.afterClosed().pipe(map((data: T) => (data ? new confirmAction(payload) : new cancelAction(payload))));
    }

    open$<T>(
        payload: T,
        cancelAction: ActionCreator<string, (props: T) => T & TypedAction<string>>,
        confirmAction: ActionCreator<string, (props: T) => T & TypedAction<string>>,
        display?: string,
        actionTitle = $localize`:@@SHARED.TEXT.DELETE:Delete`,
        suffixText = ""
    ): Observable<Action> {
        const dialogRef: MatDialogRef<DeleteConfirmationComponent> = this.dialog.open(DeleteConfirmationComponent);

        dialogRef.componentInstance.confirmationActionData = payload;
        dialogRef.componentInstance.actionTitle = actionTitle;
        dialogRef.componentInstance.suffix = suffixText;

        if (display) {
            dialogRef.componentInstance.display = display;
        }

        return dialogRef.afterClosed().pipe(map((data: T) => (data ? confirmAction(payload) : cancelAction(payload))));
    }
}
